<template>
  <div
    class="templateThree"
    v-lazy:background-image="{
      src: data.bg,
    }"
    :style="{ backgroundColor: data.bgColor }"
  >
    <title-widge
      :title="data.title"
      :titleColor="titleColor"
      :fontBg="fontBg"
    ></title-widge>
    <div class="divImg">
      <img class="divImg" :src="data.url" />
      <div class="divDesc">{{ data.desc }}</div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
    fontBg: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.templateThree {
  position: relative;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  padding-bottom: 86px;
  .divImg {
    width: 1223px;
    margin: 0 auto;
    text-align: center;
    img {
      width: 1223px;
    }
    .divDesc {
      width: 754px;
      height: 51px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 300;
      color: rgba(173, 173, 173, 1);
      margin: 0 auto;
      margin-top: 69px;
    }
  }
}
</style>
